<template lang="pug">
  .relationship-block(:class="rootClass")
    .header
      lei-popover.header-info(:text="tooltip")
        label.title {{title}}
        .statuses
          lei-popover(:text="issuedTip", placement="right")
            font-awesome-icon.second-icon(icon="link", @click="$emit('more')")
            label.status {{issued}}
          lei-popover(:text="lapsedTip", placement="right")
            font-awesome-icon.first-icon(icon="link")
            label.status {{lapsed}}
          lei-popover(v-if="!isChildren" :text="exceptionTip", placement="right")
            font-awesome-icon.third-icon(icon="link", @click="$emit('more')")
            label.status {{exception}}
    .content
      slot
</template>
<script>
import LeiPopover from '../lei-components/LeiPopover'

export default {
  components: {
    LeiPopover,
  },
  props: {
    rootClass: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    tooltip: {
      type: Object,
      default: () => {
      },
    },
    isChildren: {
      type: Boolean,
      default: false,
    },
    lapsedTip: {
      type: Object,
      default: () => ({
        small: 'A relationship record that has not been renewed by the NextRenewalDate',
        full: '',
      }),
    },
    issuedTip: {
      type: Object,
      default: () => ({
        small: 'A relationship record that has been (re-)validated and published in the past twelve months',
        full: '',
      }),
    },
    exceptionTip: {
      type: Object,
      default: () => ({
        small: 'A single reason provided by the legal entity for declining to report a parent relationship.',
        full: 'NATURAL_PERSONS - The entity is controlled by natural person(s) without any intermediate legal entity ' +
          'meeting the definition of accounting consolidating parent.\n' +
          '\n' +
          'NON_CONSOLIDATING - The accounting consolidation definition for parent relationship does not apply for the entity.\n' +
          '\n' +
          'NO_KNOWN_PERSON - There is no known person controlling the entity (e.g., diversified shareholding).\n' +
          '\n' +
          'NON_PUBLIC - The relationship information is non-public and therefore creates obstacles to releasing this information.\n' +
          '\n' +
          'NO_LEI - The parent does not consent to obtain an LEI or to authorize its ' +
          '“child entity” to obtain an LEI on its behalf.',
      }),
    },
  },
  data () {
    return {
      lapsed: 'Lapsed Relationship',
      issued: 'Published Relationship',
      exception: 'Reporting Exception',
    }
  },
}
</script>
<style lang="stylus" scoped>
  @import "../../assets/styles/variables.styl"

  .relationship-block
    background-color $default-color-light-2
    .header
      color $default-color-bold
      font-weight 600
      display flex
      align-items center
      height 40px
      padding 20px
      background-color $default-color-light-1
      @media (max-width: $mobile-l)
        height auto
        padding 10px 20px

    .content
      padding 30px 20px

    .status
      align-items: center
      display: flex
      margin-left: 5px
      text-align: center
      max-width: 600px
      position: relative


    .first-icon
      color: $danger-color
      margin-left 15px


    .second-icon
      color: $info-color
      margin-left 15px


    .third-icon
      color: $primary-color-light-5
      margin-left 15px


    .header-info
      display flex
      justify-content space-between
      width 100%
      @media (max-width: $mobile-l)
        align-items flex-start

    .title
      @media (max-width: $mobile)
        width 20%



    .statuses
      display flex
      justify-content space-between
      @media (max-width: $mobile-l)
        flex-direction column


    .lei-popover-icon
      margin-right -5px

</style>



// WEBPACK FOOTER //
// src/components/record-details/RelationshipBlock.vue